import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Box, Typography, IconButton, Menu, MenuItem, Stack, Drawer, List, ListItem, ListItemText } from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import { AccountCircle, Menu as MenuIcon } from '@mui/icons-material';
import logo from '../assets/Equity logo.png';
import { primaryColor } from '../theme';

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [role, setRole] = useState('');
  const [dashboardLink, setDashboardLink] = useState('#');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      const parsedUser = JSON.parse(user);
      setIsLoggedIn(true);
      setUsername(parsedUser.firstname);
      setRole(parsedUser.role);

      // Set the appropriate dashboard link based on the user's role
      switch (parsedUser.role) {
        case 'Head Office Admin':
          setDashboardLink('/admin/dashboard');
          break;
        case 'Regional Manager':
          setDashboardLink('/coordinator/dashboard');
          break;
        case 'Content Editor':
          setDashboardLink('/editor/dashboard');
          break;
        case 'Content Reviewer':
          setDashboardLink('/approver/dashboard');
          break;
        case 'Trainer':
          setDashboardLink('/branch/dashboard');
          break;
        default:
          setDashboardLink('#');
      }
    }
  }, []);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setUsername('');
    navigate('/login');
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const drawerList = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <ListItem button component={NavLink} to={dashboardLink}>
          <ListItemText primary="Dashboard" />
        </ListItem>
        <ListItem button component={NavLink} to="/branch/dashboard">
          <ListItemText primary="Content" />
        </ListItem>
        {(role === 'Head Office Admin' || role === 'Regional Manager') && (
          <ListItem button component={NavLink} to="/users">
            <ListItemText primary="Management" />
          </ListItem>
        )}
        {isLoggedIn && (
          <>
            <ListItem button onClick={handleLogout}>
              <ListItemText primary="Logout" />
            </ListItem>
          </>
        )}
      </List>
    </Box>
  );

  return (
    <AppBar position="static" color="default">
      <Toolbar>
        <Box display="flex" alignItems="center">
          <img src={logo} alt="Logo" style={{ width: '40px', marginRight: '10px' }} />
          <Typography variant="h6" component="div" style={{ color: primaryColor }}>
            Content Portal
          </Typography>
        </Box>
        <Box flexGrow={1} display={{ xs: 'none', md: 'flex' }} justifyContent="center">
          <Stack direction="row" spacing={2}>
            <NavLink to={dashboardLink} style={({ isActive }) => ({ color: isActive ? primaryColor : 'inherit', fontWeight: 'bold', borderBottom: isActive ? `2px solid ${primaryColor}` : 'none', textDecoration: 'none' })}>
              Dashboard
            </NavLink>
            <NavLink to="/branch/dashboard" style={({ isActive }) => ({ color: isActive ? primaryColor : 'inherit', fontWeight: 'bold', borderBottom: isActive ? `2px solid ${primaryColor}` : 'none', textDecoration: 'none' })}>
              Content
            </NavLink>
            {(role === 'Head Office Admin' || role === 'Regional Manager') && (
              <NavLink to="/users" style={({ isActive }) => ({ color: isActive ? primaryColor : 'inherit', fontWeight: 'bold', borderBottom: isActive ? `2px solid ${primaryColor}` : 'none', textDecoration: 'none' })}>
                Management
              </NavLink>
            )}
          </Stack>
        </Box>
        <Box display={{ xs: 'none', md: 'flex' }} alignItems="center">
          {isLoggedIn ? (
            <>
              <IconButton color="inherit" onClick={handleMenu}>
                <AccountCircle style={{ color: primaryColor }} />
              </IconButton>
              <Typography variant="body1" component="div" style={{ color: primaryColor, cursor: 'pointer' }} onClick={handleMenu}>
                {username}
              </Typography>
              <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleClose}>Account</MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </>
          ) : (
            <NavLink to="/login" style={{ color: primaryColor, textDecoration: 'none' }}>
              Login
            </NavLink>
          )}
        </Box>
        <Box display={{ xs: 'flex', md: 'none' }} alignItems="center" ml="auto">
          <IconButton color="inherit" onClick={toggleDrawer(true)}>
            <MenuIcon style={{ color: primaryColor }} />
          </IconButton>
          <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
            {drawerList}
          </Drawer>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;